import React, { Component } from "react";
import { Container } from "reactstrap";

class AssociationsFooter extends Component {
  render() {
    return (
      <div>
        <Container id="footer">
          <p>
            M. Le Maire est le responsable des traitements de la Ville de Metz. Les informations recueillies par le
            Cabinet du Maire, font l’objet d’un traitement informatique destiné à Publier des informations sur les
            associations et leurs activités sur metz.fr Les informations enregistrées sont utilisées par les services de
            la Ville de Metz. Vos données à caractère personnel sont conservées 2 ans. Conformément aux articles 15 à 23
            du Règlement 2016/679 du Parlement Européen et du Conseil du 27 avril 2016, toute personne peut obtenir
            communication et, le cas échéant, rectification, effacement, limitation du traitement, opposition et
            limitation des informations la concernant, pour motif légitime. Vous pouvez exercer ces droits, sous réserve
            de la fourniture d’une pièce justificative d’identité, auprès de la ville de Metz à l’adresse suivante :
          </p>
          <p>
            Hôtel de Ville de Metz
            <br />
            A l’attention du DPO
            <br />
            1, place d’Armes – J.F. Blondel – 57036 METZ Cedex 1<br />
            Téléphone : 0 800 891 891
          </p>
        </Container>
        <br />
        <br />
        <br />
        <footer className="footer" id="footer2">
          <div className="container">
            <span className="text-muted">
              <a rel="noopener noreferrer" href="https://metz.fr/ressources/informations_legales.php" target="_blank">
                Informations légales
              </a>{" "}
              -{" "}
              <a rel="noopener noreferrer" href="https://metz.fr/ressources/credit.php" target="_blank">
                Crédits
              </a>
            </span>
          </div>
        </footer>
      </div>
    );
  }
}

export default AssociationsFooter;
